import { IconButton, Stack } from '@fluentui/react';
import React, { useState } from 'react';
import { UserGroupModal } from './UserGroupModal';
import { UserGroupRowItem } from '../list';

export interface UserGroupProps {
  userGroup: UserGroupRowItem;
}
type UserGroupModalViewProps = Partial<UserGroupProps>;
export const UserGroupModalView: React.FC<UserGroupModalViewProps> = ({
  userGroup,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { _isUpdatable } = { ...userGroup };

  return (
    <Stack horizontal verticalAlign="center">
      <IconButton
        iconProps={{ iconName: 'Edit' }}
        onClick={() => setIsOpen(true)}
        disabled={!_isUpdatable}
      />
      {isOpen && (
        <UserGroupModal
          userGroup={userGroup}
          onClose={() => setIsOpen(false)}
        />
      )}
    </Stack>
  );
};
